import axios from 'axios';


export default {
  getHistory (period, period_from, period_to, wine_id = null, client_id = null, machine_id = null) {
    return axios.get(`/stats/history`, { params: { period, period_from: period_from.toISOString(), period_to: period_to.toISOString(), wine_id, client_id, machine_id } })
      .then(response => response.data);
  },
  getCount (period, period_from, period_to, wine_id = null, client_id = null, machine_id = null) {
    return axios.get(`/stats/count`, { params: { period, period_from: period_from.toISOString(), period_to: period_to.toISOString(), wine_id, client_id, machine_id } })
      .then(response => response.data);
  },
  getPerformance (period, period_from, period_to, client_id = null, machine_id = null) {
    return axios.get(`/stats/performance`, { params: { period, period_from: period_from.toISOString(), period_to: period_to.toISOString(), client_id, machine_id } })
      .then(response => response.data);
  },
  getWallOfFame (period, period_from, period_to) {
    return axios.get(`/stats/waf`, { params: { period, period_from: period_from.toISOString(), period_to: period_to.toISOString() } })
      .then(response => response.data);
  }
};
